import { withNamespaces } from "react-i18next";
import { Card, CardBody, CardTitle, Col, Label, Row } from "reactstrap";
import GeoMap from "src/modules/3rd-party-management/components/geo-map";

const Commodities = ({
    t,
    isLoading,
    traceData = {}
}) => {
    const  {
        commodities
    } = traceData;

    if (isLoading) return null;

    return (
        (Array.isArray(commodities) ? commodities : (commodities ? [commodities] : [])).map((c, idx) => (
            <Card className="mb-3 shadow-sm" key={idx}>
                <CardBody>
                    <CardTitle tag="h5" className="mb-3">
                        {t('Item No.')}:{c.position} 
                    </CardTitle>

                    <Row>
                        <Col sm='12' md='12'>
                            <Row>
                                <Col sm='12' md='6' className="mb-2">
                                    <Label className="form-label">
                                        {t('HS Code')}:
                                    </Label>
                                    <p className="text-muted mb-0">
                                        {c.hsHeading}
                                    </p>
                                </Col>

                                <Col sm='12' md='6' className="mb-2">
                                    <Label className="form-label">
                                        {t('Species (Common Name)')}:
                                    </Label>
                                    <p className="text-muted mb-0">
                                        {c.speciesInfo.commonName}
                                    </p>
                                </Col>

                                <Col sm='12' md='6' className="mb-2">
                                    <Label className="form-label">
                                        {t('Scientific Name')}:
                                    </Label>
                                    <p className="text-muted mb-0">
                                        {c.speciesInfo.scientificName}
                                    </p>
                                </Col>

                                <Col sm='12' md='6' className="mb-2">
                                    <Label className="form-label">
                                        {t('Net Weight (kg)')}:
                                    </Label>
                                    <p className="text-muted mb-0">
                                        {c.descriptors.goodsMeasure.netWeight} kg
                                    </p>
                                </Col>

                                <Col sm='12' md='12' className="mb-2">
                                    <Label className="form-label">
                                        {t('Description of Goods')}:
                                    </Label>
                                    <p className="text-muted mb-0">
                                        {c.descriptors.descriptionOfGoods}
                                    </p>
                                </Col>
                            </Row>
                        </Col>

                        <Col sm='12' md='12'>
                            <Row>
                                {(Array.isArray(c.producers) ? c.producers : (c.producers ? [c.producers] : [])).map((producer, pIdx) => (
                                    <Col sm="12" md="6">
                                        <Card className="mt-2" key={pIdx}>
                                            <CardBody className="text-center bg-light">
                                                <div>
                                                    <strong className="me-2">
                                                        {t('Country of Production')}:
                                                    </strong>
                                                    <span>
                                                        {producer.country}
                                                    </span>
                                                </div>

                                                <div>
                                                    <strong className="me-2">
                                                        {t('Production Area (ha)')}:
                                                    </strong>
                                                    <span>
                                                        {producer.geometryGeojson.features[0].properties.Area}
                                                    </span>
                                                </div>

                                                <div className="mt-2">
                                                    <div>
                                                        <GeoMap
                                                            readOnly={true}
                                                            preDefinedGeo={producer.geometryGeojson?.features}
                                                            multiDraw={true}
                                                            styles={{
                                                                height: '300px'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        ))
    )
}

export default withNamespaces()(
    Commodities
);